import { render, staticRenderFns } from "./IncidencesMobileListItem.vue?vue&type=template&id=70babf2c&"
import script from "./IncidencesMobileListItem.vue?vue&type=script&lang=js&"
export * from "./IncidencesMobileListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports